import PropTypes from 'prop-types'
/**
 * code from https://github.com/tj/react-click-outside
 */
import React, { Component } from 'react'

export default class ClickOutside extends Component {
  static propTypes = {
    onClickOutside: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.setWrapperRef = this.setWrapperRef.bind(this)
  }

  setWrapperRef(ref) {
    if (ref !== null) {
      this.container = ref
    }
  }

  render() {
    const { children } = this.props
    return <div ref={this.setWrapperRef}>{children}</div>
  }

  componentDidMount() {
    document.addEventListener('click', this.handle, true)
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handle, true)
  }

  handle = e => {
    const { onClickOutside } = this.props
    const el = this.container
    if (!el.contains(e.target)) onClickOutside(e)
  }
}



// WEBPACK FOOTER //
// ./client/components/clickOutside.js